import { render, staticRenderFns } from "./UserlocationInviteForm.vue?vue&type=template&id=dd2dcafa&"
import script from "./UserlocationInviteForm.vue?vue&type=script&lang=js&"
export * from "./UserlocationInviteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports